import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { ROLES, STATUS_IDENTIFIERS } from "models";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Appointment } from "models";

export const useCanDeleteLastCheck = (appointment: Appointment) => {
  const { user } = usePermanentRealTimeUser();

  if (appointment.appointment_status_identifier !== STATUS_IDENTIFIERS.CarCheckStatus || !user) return false;

  return [ROLES.SuperAdmin, ROLES.ClaireAdmin, ROLES.SupportAdmin, ROLES.DealerAdmin].includes(user.role_id);
};

type DeletedLastCheckPayload = {
  appointment_id: number;
  check_id: number;
};

export const useDeleteLastCheckMutation = () =>
  useTypedMutation({
    mutationFn: async ({ appointment_id }: DeletedLastCheckPayload) => {
      await ApiInstance.post("/checks/last/delete", { appointment_id });
    },
    onSuccess: ({ check_id }) => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks?.length) return;

      const checkIdx = checks.findIndex(c => c.id === check_id);
      if (checkIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.checks, checks.toSpliced(checkIdx, 1));
    }
  });
